import { useEffect, useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";

export default function LoginBox({
  session,
  email,
  setEmail,
  password,
  setPassword,
  isAdmin,
  handleLogin,
  handleLogout,
  styles,

  isPasswordRecovery,
  newPassword,
  setNewPassword,
  handleUpdatePassword,

  handleForgotPassword,

  authMode,
  setAuthMode,
  signupUsername,
  setSignupUsername,
  signupFullName,
  setSignupFullName,
  handleSignup,
  setPage,
}) {
  const { t } = useLanguage();

  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth <= 768
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const ui = {
    shell: {
      width: "100%",
      maxWidth: "1180px",
      margin: "0 auto",
      background: "#ffffff",
      borderRadius: "24px",
      overflow: "hidden",
      boxShadow: "0 22px 60px rgba(15, 23, 42, 0.12)",
      border: "1px solid rgba(148, 163, 184, 0.18)",
    },

    topBar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "20px",
      padding: "22px 30px",
      borderBottom: "1px solid #eef2f7",
    },

    brandWrap: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
    },

    logo: {
      width: "42px",
      height: "42px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background:
        "linear-gradient(135deg, #2563eb 0%, #60a5fa 100%)",
      color: "#ffffff",
      fontSize: "20px",
      fontWeight: "800",
      boxShadow: "0 6px 16px rgba(37, 99, 235, 0.22)",
    },

    brandName: {
      fontSize: "20px",
      fontWeight: "800",
      color: "#172033",
      letterSpacing: "-0.3px",
    },

    languageSelect: {
      appearance: "none",
      WebkitAppearance: "none",
      border: "1px solid #dbe3ee",
      borderRadius: "12px",
      padding: "10px 38px 10px 14px",
      fontSize: "14px",
      fontWeight: "600",
      color: "#334155",
      background:
        "#ffffff url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 20 20'%3E%3Cpath fill='%2364748b' d='M5.5 7.5L10 12l4.5-4.5z'/%3E%3C/svg%3E\") no-repeat right 12px center",
      cursor: "pointer",
      outline: "none",
    },

    main: {
      display: "grid",
      gridTemplateColumns: "1.08fr 0.92fr",
      minHeight: "570px",
    },

    hero: {
      padding: "58px 52px",
      background:
        "linear-gradient(145deg, #f5f9ff 0%, #eef6ff 48%, #f8fbff 100%)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },

    headline: {
      margin: "0 0 18px",
      maxWidth: "560px",
      fontSize: "42px",
      lineHeight: "1.12",
      letterSpacing: "-1.3px",
      color: "#172033",
      fontWeight: "850",
    },

    subtitle: {
      maxWidth: "560px",
      margin: "0 0 34px",
      color: "#64748b",
      fontSize: "16px",
      lineHeight: "1.7",
    },

    featureGrid: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "16px",
    },

    feature: {
      display: "flex",
      gap: "12px",
      alignItems: "flex-start",
      padding: "15px",
      borderRadius: "15px",
      background: "rgba(255,255,255,0.72)",
      border: "1px solid rgba(219, 227, 238, 0.8)",
    },

    featureIcon: {
      flex: "0 0 32px",
      width: "32px",
      height: "32px",
      borderRadius: "10px",
      background: "#e8f1ff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#2563eb",
      fontSize: "16px",
    },

    featureTitle: {
      color: "#1e293b",
      fontSize: "14px",
      lineHeight: "1.35",
      fontWeight: "750",
      marginBottom: "4px",
    },

    featureDesc: {
      color: "#64748b",
      fontSize: "12px",
      lineHeight: "1.5",
    },

    formSide: {
      padding: "58px 54px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      background: "#ffffff",
    },

    formTitle: {
      fontSize: "30px",
      lineHeight: "1.2",
      color: "#172033",
      fontWeight: "800",
      marginBottom: "9px",
    },

    formSubtitle: {
      color: "#64748b",
      lineHeight: "1.55",
      fontSize: "14px",
      marginBottom: "26px",
    },

    label: {
      display: "block",
      marginBottom: "7px",
      color: "#334155",
      fontSize: "13px",
      fontWeight: "700",
    },

    input: {
      boxSizing: "border-box",
      width: "100%",
      height: "48px",
      border: "1px solid #dbe3ee",
      borderRadius: "11px",
      padding: "0 14px",
      marginBottom: "17px",
      fontSize: "15px",
      color: "#1e293b",
      background: "#ffffff",
      outline: "none",
    },

    primary: {
      width: "100%",
      minHeight: "48px",
      border: "none",
      borderRadius: "11px",
      background:
        "linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)",
      color: "#ffffff",
      fontSize: "15px",
      fontWeight: "750",
      cursor: "pointer",
      boxShadow: "0 8px 20px rgba(37, 99, 235, 0.2)",
    },

    textButton: {
      border: "none",
      background: "transparent",
      color: "#2563eb",
      cursor: "pointer",
      padding: "7px 3px",
      fontSize: "13px",
      fontWeight: "650",
    },

    actions: {
      marginTop: "13px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },

    divider: {
      height: "1px",
      background: "#eef2f7",
      width: "100%",
      margin: "10px 0 5px",
    },

    accountText: {
      color: "#64748b",
      fontSize: "13px",
    },

    security: {
      marginTop: "26px",
      color: "#94a3b8",
      fontSize: "11px",
      lineHeight: "1.5",
      textAlign: "center",
    },
  };

  const renderFormContent = () => {
    if (isPasswordRecovery) {
      return (
        <>
          <div style={ui.formTitle}>
            {t("login.resetPassword")}
          </div>

          <div style={ui.formSubtitle}>
            {t("login.resetPasswordSubtitle")}
          </div>

          <label style={ui.label}>
            {t("login.newPassword")}
          </label>

          <input
            type="password"
            placeholder={t("login.newPassword")}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            style={ui.input}
          />

          <button
            style={ui.primary}
            onClick={handleUpdatePassword}
          >
            {t("login.updatePassword")}
          </button>
        </>
      );
    }

    if (!session && authMode === "signup") {
      return (
        <>
          <div style={ui.formTitle}>
            {t("login.studentSignup")}
          </div>

          <div style={ui.formSubtitle}>
            {t("login.signupSubtitle")}
          </div>

          <label style={ui.label}>
            {t("login.fullName")}
          </label>

          <input
            type="text"
            placeholder={t("login.fullName")}
            value={signupFullName}
            onChange={(e) => setSignupFullName(e.target.value)}
            style={ui.input}
          />

          <label style={ui.label}>
            {t("login.username")}
          </label>

          <input
            type="text"
            placeholder={t("login.username")}
            value={signupUsername}
            onChange={(e) => setSignupUsername(e.target.value)}
            style={ui.input}
          />

          <label style={ui.label}>
            {t("login.email")}
          </label>

          <input
            type="email"
            placeholder={t("login.email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={ui.input}
          />

          <label style={ui.label}>
            {t("login.password")}
          </label>

          <input
            type="password"
            placeholder={t("login.password")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={ui.input}
          />

          <button
            style={ui.primary}
            onClick={handleSignup}
          >
            {t("login.signupButton")}
          </button>

          <div style={ui.actions}>
            <button
              style={ui.textButton}
              onClick={() => setAuthMode("login")}
            >
              {t("login.alreadyHaveAccount")}
            </button>
          </div>
        </>
      );
    }

    if (!session) {
      return (
        <>
          <div style={ui.formTitle}>
            {t("login.studentLogin")}
          </div>

          <div style={ui.formSubtitle}>
            {t("login.loginSubtitle")}
          </div>

          <label style={ui.label}>
            {t("login.email")}
          </label>

          <input
            type="email"
            placeholder={t("login.email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={ui.input}
          />

          <label style={ui.label}>
            {t("login.password")}
          </label>

          <input
            type="password"
            placeholder={t("login.password")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={ui.input}
          />

          <button
            style={ui.primary}
            onClick={handleLogin}
          >
            {t("login.loginButton")}
          </button>

          <div style={ui.actions}>
            <button
              style={ui.textButton}
              onClick={handleForgotPassword}
            >
              {t("login.forgotPassword")}
            </button>

            <div style={ui.divider} />

            <div style={ui.accountText}>
              {t("login.noAccount")}{" "}
              <button
                style={ui.textButton}
                onClick={() => setAuthMode("signup")}
              >
                {t("login.createAccount")}
              </button>
            </div>
          </div>

          <div style={ui.security}>
            🔒 {t("login.security")}
          </div>
        </>
      );
    }

    return (
      <>
        <div style={ui.formTitle}>
          {t("login.welcomeBack")}
        </div>

        <div style={ui.formSubtitle}>
          {session.user.email}
        </div>

        {isAdmin && (
          <div style={styles.adminBadge}>
            {t("login.superUserAccess")}
          </div>
        )}

        {isAdmin && (
          <button
            style={{
              ...ui.primary,
              marginTop: "18px",
            }}
            onClick={() => setPage("admin")}
          >
            {t("login.adminDashboard")}
          </button>
        )}

        <button
          style={{
            ...ui.primary,
            marginTop: "12px",
            background: "#64748b",
            boxShadow: "none",
          }}
          onClick={handleLogout}
        >
          {t("login.logout")}
        </button>
      </>
    );
  };

  return (
    <div
      style={{
        ...ui.shell,
        ...(isMobile
          ? {
              width: "100%",
              maxWidth: "100%",
              borderRadius: "16px",
            }
          : {}),
      }}
    >
      <div style={ui.topBar}>
        <div style={ui.brandWrap}>
          <div style={ui.logo}>✦</div>

          <div style={ui.brandName}>
            {t("login.brand")}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
          }}
        >
        </div>
      </div>

      <div
        style={{
          ...ui.main,
          ...(isMobile
            ? {
                display: "flex",
                flexDirection: "column",
                minHeight: "auto",
              }
            : {}),
        }}
      >
        <section
          style={{
            ...ui.hero,
            ...(isMobile
              ? {
                  order: 2,
                  padding: "34px 22px",
                }
              : {}),
          }}
        >
          <h2
            style={{
              ...ui.headline,
              ...(isMobile
                ? {
                    fontSize: "30px",
                    lineHeight: "1.18",
                    letterSpacing: "-0.8px",
                  }
                : {}),
            }}
          >
            {t("login.headline")}
          </h2>

          <p style={ui.subtitle}>
            {t("login.subtitle")}
          </p>

          <div
            style={{
              ...ui.featureGrid,
              ...(isMobile
                ? {
                    gridTemplateColumns: "1fr",
                    gap: "12px",
                  }
                : {}),
            }}
          >
            <div style={ui.feature}>
              <div style={ui.featureIcon}>✓</div>
              <div>
                <div style={ui.featureTitle}>
                  {t("login.featureExam")}
                </div>
                <div style={ui.featureDesc}>
                  {t("login.featureExamDesc")}
                </div>
              </div>
            </div>

            <div style={ui.feature}>
              <div style={ui.featureIcon}>↗</div>
              <div>
                <div style={ui.featureTitle}>
                  {t("login.featureAdaptive")}
                </div>
                <div style={ui.featureDesc}>
                  {t("login.featureAdaptiveDesc")}
                </div>
              </div>
            </div>

            <div style={ui.feature}>
              <div style={ui.featureIcon}>▤</div>
              <div>
                <div style={ui.featureTitle}>
                  {t("login.featureTopics")}
                </div>
                <div style={ui.featureDesc}>
                  {t("login.featureTopicsDesc")}
                </div>
              </div>
            </div>

            <div style={ui.feature}>
              <div style={ui.featureIcon}>✦</div>
              <div>
                <div style={ui.featureTitle}>
                  {t("login.featureAI")}
                </div>
                <div style={ui.featureDesc}>
                  {t("login.featureAIDesc")}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          style={{
            ...ui.formSide,
            ...(isMobile
              ? {
                  order: 1,
                  padding: "34px 22px",
                }
              : {}),
          }}
        >
          {renderFormContent()}
        </section>
      </div>
    </div>
  );
}